/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import intl from 'react-intl-universal'
import { animated, Spring } from 'react-spring/renderprops.cjs'
import { IFeaturedMediaCardHeader } from './types'

const renderTickSpan = (style) => {
  return <animated.div style={{ ...style }} className="px-1 fa fa-sort-desc" />
}

const getTransition = (collapsed) => ({
  transform: collapsed ? 'rotate(0deg)' : 'rotate(-90deg)',
})

const FeaturedMediaCardHeader = (props: IFeaturedMediaCardHeader) => (
  <div className="row">
    {/* Not sure a role here makes sense unless other correct composite roles are used as well */}
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events  */}
    <div className="col header-container" onClick={props.toggleCollapsed}>
      <strong>
        {props.label}
        <Spring
          native={true}
          from={{ transform: 'rotate(0deg)' }}
          to={getTransition(!props.collapsed)}
        >
          {renderTickSpan}
        </Spring>
      </strong>
    </div>
    <div className="col">
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events  */}
      <a
        className="px-2 float-right bulma--tooltip is-tooltip-top"
        data-tooltip={intl.get('settings.featuredMedia.remove')}
        onClick={props.remove}
        role="tooltip"
      >
        <i className="fa fa-trash-o" />
      </a>
    </div>
  </div>
)

export default FeaturedMediaCardHeader
